import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';

class FormPlusButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        addDetail: PropTypes.func.isRequired,
    };

    static defaultProps = {};

    render() {
        const { addDetail, classes } = this.props;

        return (
            <div style={{ height: 72, display: 'flex', alignItems: 'center' }}>
                <Tooltip title={Translator.translate('general.add')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.add')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={addDetail}
                    >
                        <AddIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    btnEdit: {
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30,
        },
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem',
        },
    },
});

export default withStyles(styles, { withTheme: true })(FormPlusButton);



// WEBPACK FOOTER //
// ./data/components/FormPlusButton.js